import { RegisterPaymentApiAccountsApi } from "@/features/accounts/payment/api/services/register-accounts-api";
import { RegisterPaymentApiAccountsRequestModel } from "@/features/accounts/payment/api/services/register-accounts-model";

/// MoneyLook 口座登録認可開始画面要求（API版）処理
export class RegisterPaymentApiAccountsService {
  private registerPaymentApiAccountsApi = new RegisterPaymentApiAccountsApi();

  /**
   * MoneyLook 口座登録認可開始画面要求（API版）API実行
   */
  public async registerPaymentApiAccounts(param: RegisterPaymentApiAccountsRequestModel) {
    return await this.registerPaymentApiAccountsApi.registerPaymentApiAccounts(param);
  }
}
